import referrals from './referrals'

export default { referrals }
